const lightShadowColor = 'rgba(0,0,0,0.04)';
const lightShadowColorStrong = 'rgba(0,0,0,0.085)';
const darkShadowColor = 'rgba(0,0,0,0.2)';
const darkShadowColorStrong = 'rgba(0,0,0,0.3)';

export const shadows = {
    light: {
        shadowColor: lightShadowColorStrong,
        shadowColorHover: lightShadowColorStrong,
        shadowColorPress: lightShadowColor,
        shadowColorFocus: lightShadowColor,
    },
    dark: {
        shadowColor: darkShadowColorStrong,
        shadowColorHover: darkShadowColorStrong,
        shadowColorPress: darkShadowColor,
        shadowColorFocus: darkShadowColor,
    },
};
